const enum UntitledColorTypes {
  primary = 'Primary',
  secondaryGray = 'Secondary Gray',
  secondaryColor = 'Secondary Color',
  tertiaryGray = 'Tertiary Gray',
  tertiaryColor = 'Tertiary Color',
  linkGray = 'Link Gray',
  linkColor = 'Link Color',
}

export default UntitledColorTypes
